import { config } from '@/utils/config';
import { SessionStorage } from '@witkac/kartamiejska-shared';

export const mediaMixin = {
  data() {
    const baseMediaUrl = config.mediaURL && config.mediaURL.endsWith('/') ? config.mediaURL : config.mediaURL + '/';
    const apiBaseUrl = baseMediaUrl.replace(/\/media\/?$/, '/');
    return {
      mediaUrl: baseMediaUrl,
      applicationScopedMediaUrl: `${apiBaseUrl}application/`
    };
  },
  methods: {
    // @vuese
    // URL do pobrania pliku
    downloadUrl(id) {
      return this.mediaUrl + id;
    },

    applicationScopedDownloadUrl(applicationId, id) {
      const parsedApplicationId = parseInt(applicationId, 10);
      if (!Number.isInteger(parsedApplicationId) || parsedApplicationId < 1) {
        throw new Error('INVALID_APPLICATION_ID');
      }

      return this.applicationScopedMediaUrl + parsedApplicationId + '/media/' + id;
    },

    async downloadApplicationMedia(applicationId, media) {
      return this.downloadMediaByUrl(this.applicationScopedDownloadUrl(applicationId, media.id), media);
    },

    async downloadMediaByUrl(url, media) {
      const token = localStorage.getItem(SessionStorage.TOKEN);
      const response = await fetch(url, {
        headers: token
          ? {
              Authorization: `Bearer ${token}`
            }
          : {}
      });

      if (!response.ok) {
        throw new Error('DOWNLOAD_FAILED');
      }

      const blob = await response.blob();
      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = media.title || `plik-${media.id}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(objectUrl);
    }
  }
};
